// NOTE: mixin expects computed boolean property "preventExit"

export default {
  mounted() {
    window.addEventListener("beforeunload", this.onBeforeUnload)
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.onBeforeUnload)
  },

  beforeRouteLeave(to, from, next) {
    if (this.preventExit) {
      // eslint-disable-next-line no-console
      console.log("You shall not pass!")
    }

    const msg = "You have unsaved changes. Are you sure you want to leave?"
    if (!this.preventExit || confirm(msg)) return next()
  },

  methods: {
    onBeforeUnload(e) {
      if (!this.preventExit) return

      // eslint-disable-next-line no-console
      console.log("You shall not pass!")

      e.preventDefault()
      e.returnValue = ""
    }
  }
}
